import { render, staticRenderFns } from "./SecshaZone.vue?vue&type=template&id=4219d1f4&scoped=true"
import script from "./SecshaZone.vue?vue&type=script&lang=js"
export * from "./SecshaZone.vue?vue&type=script&lang=js"
import style0 from "./SecshaZone.vue?vue&type=style&index=0&id=4219d1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4219d1f4",
  null
  
)

export default component.exports